// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonNavbarBottom {
    display: inline-flex;
    width: 4rem;
    flex-direction: column;
    align-items: center;
    justify-content: center
}
`, "",{"version":3,"sources":["webpack://./src/components/BottomNavbar/style.css"],"names":[],"mappings":"AACI;IAAA,oBAA2D;IAA3D,WAA2D;IAA3D,sBAA2D;IAA3D,mBAA2D;IAA3D;AAA2D","sourcesContent":[".buttonNavbarBottom{\n    @apply inline-flex flex-col items-center justify-center w-16 \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
